export const xlBreakpoint = 1440;
export const lgBreakpoint = 1310;
export const mdLgBreakpoint = 1120;
export const mdBreakpoint = 860;
export const smMdBreakpoint = 678;
export const smBreakpoint = 420;
